<script>
export default {
  created() {
    this.onLoad();
  },
  data: () => ({
    imageUrl: null,
  }),
  methods: {
    async onLoad() {
      let url = `/admin/application/file/${this.$route.params.id}`;
      if (
        this.$route.params.mode === "view" ||
        this.$route.params.mode === "download"
      ) {
        url += `/${this.$route.params.mode}`;
      }
      const response = await this.$axios.get(url, {
        responseType: "arraybuffer", // Set the response type to arraybuffer for binary data
      });

      // Convert the binary data to a URL that can be used as the image source
      this.imageUrl = `data:image/jpeg;base64,${btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      )}`;
    },
  },
};
</script>
<template>
  <div style="align-content: center">
    <img :src="imageUrl" alt="Image" v-if="imageUrl" />
  </div>
</template>
